"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateItems = void 0;
const generateItems = (count, cb) => {
    return Array.from(new Array(count), (_, idx) => cb(idx));
};
exports.generateItems = generateItems;
